module.exports = __webpack_public_path__ + "img/companies_02.03396b93.jpeg";